import { useSelector } from 'sierra-client/state/hooks'
import {
  selectOrganizationTenantId,
  selectOrganizationUuid,
} from 'sierra-client/state/organization/selectors'

export const useOrgTenantId = (): string | undefined => useSelector(selectOrganizationTenantId)
export const useOrgId = (): string | undefined => useSelector(selectOrganizationUuid)
